export default (props, vars) => () =>
  vars?.['usestateappdetailspopup']?.['setState'](undefined);
